import React from 'react';
import ReactPaginate from 'react-paginate';
import { I18n } from 'aws-amplify';

import ContentBlock from './contentblock.js'
import CruiseSettingBlockMaker from './cruiseSettingBlockMaker.js';

import { CRUISE_PER_PAGE } from '../../../configures/val.js';

export default class MierukaManagePagenation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      offset: 0,
      pageCount: 0,
    };
  }

  // offset: 現在表示されている数
  // offsetからperPage分のデータを切り出して返す
  getDemoData = (offset) => {
    const sliced = this.props.content.slice(offset, CRUISE_PER_PAGE + offset);
    const data = {
      settings: sliced,
      dataLength: this.props.content.length,
    }
    return data;
  }

  updateView = () => {
    // クリックされると、都度切り出して、表示する
    const data = this.getDemoData(this.state.offset);

    // ページネーションの最大値を決める
    const pageCount = Math.ceil(data.dataLength/CRUISE_PER_PAGE);

    this.setState({
      data,
      pageCount
    });
  }

  componentDidMount() {
    this.updateView();
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * CRUISE_PER_PAGE);

    this.setState({ offset: offset }, () => {
      this.updateView();
    });
  }
  showBlock = () => {
    // blocksはReact要素を持つ配列。
    // React要素自体はいろんなものが入ったオブジェクト
    // つまりただのオブジェクトの配列
    let blocks = [];
    if (this.props.pageNationType === 'manage') {
      blocks = this.state.data.settings.map((value, index) => {
        const myKey = 'cruisesettingblock_' + index;
        return (
          <ContentBlock
            key = {myKey}
            contentBody={value}
            idx={index}
            openSnack={this.props.openSnack}
          />
        );
      }
      );
    } else {
      const that = this;
      blocks = this.props.content.map((value, index) => {
        // assetId + screenId の文字列を連結させてユニークなkeyを作る
        const myKey = 'cruisesettingblock_' + value.asset.assetId + value.asset.screenId;
        return (
          <CruiseSettingBlockMaker
            key = {myKey}
            setting={value}
            idx={(index + 1)}
            openCarousel={that.props.toOpenCarousel}
            reportMyState={that.props.updateChildState}
            updatePostCruiseSetting={this.props.updatePostCruiseSetting}
            imgsrc={this.props.imgSet[index]}
          />);
      });
    }
    return(
      <div>
        {blocks}
      </div>
    );
  }
  checkShowPagenation = () => {
    if (this.state.data.hasOwnProperty('settings')) {
      if (this.props.content.length <= CRUISE_PER_PAGE) {
        return (<div />);
      } else {
        return (
          <ReactPaginate
            previousLabel={I18n.get('Previous')}
            nextLabel={I18n.get('Next')}
            breakLabel={'...'}
            breakClassName={'breakLink'}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={this.handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
        );
      }
    } else {
      return (<div />);
    }
  }
  render() {
    return (
      <div>
        {// 最初の読み込み時はdataにsettingsがない場合がある (didMount()がまだ走ってないとき)ので、チェックしておく
        }
        {this.state.data.hasOwnProperty('settings') ? this.showBlock(): <div />}
        {this.checkShowPagenation()}
      </div>
    );
  }
}
